/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgPaginationFirstPage: React.FC<React.SVGAttributes<
    SVGElement
>> = (props) => (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.75 19c.414 0 .75-.294.75-.656V5.656C8.5 5.294 8.164 5 7.75 5S7 5.294 7 5.656v12.688c0 .362.336.656.75.656zm9.78-12.47a.75.75 0 00-1.06-1.06l-6 6a.75.75 0 000 1.06l6 6a.75.75 0 101.06-1.06L12.06 12l5.47-5.47z"
            fill="currentColor"
        />
    </svg>
);
